import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeHistoryByCharge = async ({
    token,
    charge_id,
    limit = 10,
    skip = 0,
    sort_order,
    sort_by,
}) => {

    const params = {
        charge_id,
        limit,
        skip,
        sort_order,
        sort_by,
    }

    try {
        const res = await axiosCreate.get('/charge/instance', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}